import { useEffect, useState } from 'react';

import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BooleanParam, useQueryParam, withDefault } from 'use-query-params';

import { ReportCells } from '../../../components/ReportCells';
import ReportVersion from '../Form';
import { useGetReportVersion } from '../hooks';
import { label } from '../Translate/translation';
const Index = () => {
  const { tab, idVersion } = useParams<Record<string, string>>();
  const [key, setKey] = useState(tab);
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  const [disabled] = useQueryParam('disabled', withDefault(BooleanParam, false));
  useEffect(() => {
    if (tab !== key) {
      setKey(tab);
    }
  }, [tab, key]);
  const { t, i18n } = useTranslation();
  const { data: reportVersionData } = useGetReportVersion(idVersion ?? '');
  return (
    <>
      <Tabs
        id="controlled-tab-example"
        unmountOnExit={true}
        activeKey={key}
        className="nav-fill"
        onSelect={(k) => navigate(url.replace(key as string, k as string))}
      >
        <Tab disabled={disabled} eventKey="general" title={label('tabVersion')}>
          {reportVersionData ? <ReportVersion defaultValue={reportVersionData} /> : <></>}
        </Tab>
        <Tab disabled={disabled} eventKey="cells" title={label('fields')}>
          <ReportCells idVersion={idVersion ?? ''} />
        </Tab>
      </Tabs>
    </>
  );
};

export default Index;
